const getStoreAddress = (store)=>{
    if (!store) return '';
    return `${store.streetName}${store.streetNumber ? ` ${store.streetNumber}` : ''}${store.additionalStreetInfo ? ` ${store.additionalStreetInfo}` : ''}, ${store.city}`;
};

export { getStoreAddress };
//# sourceMappingURL=get-store-address.js.map
